export const API_URL = 'https://siggybyoga.femtoweb.co.uk/payments/'
export const REACT_APP_STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || 'pk_test_<YOUR_PUBSHICHABLE_KEY>'
export const GoogleClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;